import { useCallback, useState } from 'react'

export function useDisclosure(defaultValue?: boolean) {
  const [isOpen, setIsOpen] = useState(defaultValue ?? false)

  const close = useCallback(() => setIsOpen(false), [])
  const open = useCallback(() => setIsOpen(true), [])
  const onToggle = useCallback(() => setIsOpen((p) => !p), [])

  return { isOpen, open, close, onToggle }
}
